/**
 * Représente une tâche
 */
import { StatusTask } from '@/core/Common'
import type { APIResource } from '@/core/resources/APIResource'

export class Task implements APIResource {
  apiRoute: string = 'tasks'

  id: number = -999
  name: string = ''
  last_error: string = ''
  run_at: Date = new Date()
  attempts: number = 0
  status: StatusTask = StatusTask.WAITING
  username: string = ''

  getIdentifier(): any {
    return this.id
  }

  fromJson(json: TaskResponse): this {
    this.id = json.id
    this.name = json.verbose_name
    this.last_error = json.last_error
    this.attempts = json.attempts
    this.status = {
      completed: StatusTask.SUCCESS,
      running: StatusTask.RUNNING,
      failed: StatusTask.FAILED,
      pending: StatusTask.WAITING
    }[json.status]!
    this.run_at = new Date(json.run_at)
    this.username = json.username
    return this
  }
}

export interface TaskResponse {
  id: number
  verbose_name: string
  run_at: string
  last_error: string
  attempts: number
  status: string
  username: string
}

export default Task
